<template>
  <div>

    <div v-show="step == 1">

      <div class="mt-1">
        <Insurance @insurance-data-completed="getInsuranceDataCheckout" :initInsuranceData="initInsuranceData" />
      </div>

    </div>

    <div v-show="step == 2">

      Onlineangebot anfordern

    </div>

  </div>
</template>

<script>
import Insurance from "./Insurance.vue";

export default {

  name: 'KSROnlineOffer',
  components: {Insurance},
  data() {
    return {
      studioId: null,
      insuranceData: false,
      initInsuranceData: 1,
      step: 1
    }
  },
  created() {

    // get studioId from parent
    this.studioId = this.$parent.studioId;

  },
  methods: {
    /*onStep2() {
      // scroll down
      setTimeout(function() {
        var element = document.querySelector("#booking-container");
        element.scrollIntoView();
      }, 200);
      this.step = 2;
    },
    */
    getInsuranceDataCheckout(value) {

      console.log(value);
      //console.log(value.damagetype);
      this.insuranceData = value;

      // save in local storage
      localStorage.setItem('insuranceData', JSON.stringify(this.insuranceData || {}));

      // go to step 2
      //this.step = 2;
      this.$router.push('/online-offer-checkout/create');

      //this.rootSection = '';
      /*if(this.jobId) {
        this.$router.push('/viewing-appointment-checkout/' + this.jobId);
      }
      else {
        this.$router.push('/viewing-appointment-checkout/create');
      }*/
    },
  }
}
</script>